module.exports = __webpack_public_path__ + "img/index-solution-03.c7236826.jpg";